import { Meter } from '@base-ui/react/meter';
import { ScoreBadge } from '@/components/ui/ScoreBadge';
import {
  subScoreIndicatorVariants,
  subScoreTier,
} from '@/components/ui/SubScoreBar';
import { cx } from '@/cva.config';
import { type ScoreBreakdown, scoreTier } from '@/lib/score';

interface ScoreSubBarsProps {
  breakdown?: ScoreBreakdown;
  score: number | null;
}

const SUB_BAR_PARTS = [
  { key: 'roleFit', label: 'R' },
  { key: 'techMatch', label: 'T' },
  { key: 'comp', label: 'C' },
  { key: 'logistics', label: 'L' },
] as const;

const TIER_TEXT_COLOR = {
  high: 'text-score-high',
  low: 'text-score-low',
  mid: 'text-score-mid',
  none: 'text-foreground-muted',
} as const;

export const ScoreSubBars = ({ score, breakdown }: ScoreSubBarsProps) =>
  !breakdown ? (
    <ScoreBadge score={score} />
  ) : (
    <div className="flex min-w-21 shrink-0 items-center gap-4">
      <span
        className={cx(
          'font-mono text-sm lg:text-base font-semibold tabular-nums',
          score !== 0 && TIER_TEXT_COLOR[scoreTier(score)],
        )}
      >
        {score ?? '–'}
      </span>
      <div className="flex flex-col gap-0.5">
        {SUB_BAR_PARTS.map(({ key, label }) => {
          const value = breakdown[key];

          return (
            <Meter.Root
              className="flex items-center gap-1.5"
              key={label}
              max={25}
              value={value}
            >
              <Meter.Label className="w-2 font-mono text-2xs text-subtle">
                {label}
              </Meter.Label>
              <Meter.Track className="h-0.75 w-10 overflow-hidden rounded-full bg-border">
                <Meter.Indicator
                  className={cx(
                    subScoreIndicatorVariants({
                      tier: subScoreTier(value, 25),
                    }),
                  )}
                />
              </Meter.Track>
            </Meter.Root>
          );
        })}
      </div>
    </div>
  );
